<ng-container *ngIf="chipListItems?.length > 0">
    <h3>Συμμετέχοντες στην {{ transferType$ }}</h3>
    <div class="chip-list">
        <ng-container *ngFor="let chipListItem of chipListItems">
            <app-chip-list-item
                [chipConfig]="chipListItem"
            ></app-chip-list-item>
        </ng-container>
    </div>
    <h6>Επιλέξτε το Χ για άρση της συμμετοχής του επιλεγμένου προσώπου</h6>
</ng-container>
